import { useTranslation } from "react-i18next";
import { FolderOpen } from "lucide-react";
import type { FileNameMapping } from "./types";

export const FileInventorySection = ({
  files,
}: {
  files?: FileNameMapping[];
}) => {
  const { t } = useTranslation();

  if (!files || files.length === 0) return null;

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div className="px-5 py-3.5 border-b border-gray-100 flex items-center gap-2.5">
        <div className="w-8 h-8 rounded-lg bg-teal-50 flex items-center justify-center">
          <FolderOpen size={16} className="text-teal-600" />
        </div>
        <h3 className="text-sm font-semibold text-gray-900">
          {t("smartSurveyor.researchReport.fileInventory")}
        </h3>
        <span className="text-xs text-gray-400 ml-auto">
          {files.length} {t("smartSurveyor.researchReport.files")}
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50/80 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
              <th className="px-5 py-2.5">
                {t("smartSurveyor.researchReport.fileHeaders.suggested")}
              </th>
              <th className="px-5 py-2.5">
                {t("smartSurveyor.researchReport.fileHeaders.original")}
              </th>
              <th className="px-5 py-2.5 text-center">
                {t("smartSurveyor.researchReport.fileHeaders.pages")}
              </th>
              <th className="px-5 py-2.5">
                {t("smartSurveyor.researchReport.fileHeaders.types")}
              </th>
              <th className="px-5 py-2.5">
                {t("smartSurveyor.researchReport.fileHeaders.focus")}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {files.map((f, i) => (
              <tr
                key={i}
                className="hover:bg-gray-50/50 transition-colors"
              >
                <td className="px-5 py-2.5 font-medium text-gray-900">
                  {f.suggested || f.original}
                </td>
                <td className="px-5 py-2.5 text-gray-400 text-xs font-mono truncate max-w-[180px]">
                  {f.original}
                </td>
                <td className="px-5 py-2.5 text-center">
                  <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-gray-100 text-xs font-medium text-gray-600">
                    {f.page_count || "—"}
                  </span>
                </td>
                <td className="px-5 py-2.5">
                  <div className="flex flex-wrap gap-1">
                    {f.doc_types?.map((dt, j) => (
                      <span
                        key={j}
                        className="text-xs bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded"
                      >
                        {dt.replace(/_/g, " ")}
                      </span>
                    ))}
                  </div>
                </td>
                <td className="px-5 py-2.5 text-xs text-gray-500">
                  {f.surveyor_focus || ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
